import React, { Fragment, useEffect, useState } from "react";
import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { getProducts } from "../actions/productActions";
import Loader from "./Layouts/Loader";
import MetaData from "./Layouts/MetaData";
import Product from "./products/Product";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

function Home(props) {
  const dispatch = useDispatch();
  const params = useParams();
  const [price, setPrice] = useState([1, 200000]);
  const [rating, setRating] = useState(0);

  const [category, setCategory] = useState("");

  const { keyword } = params;
  const alert = useAlert();
  const { products, loading, error, productsCount } = useSelector(
    (state) => state.products,
  );
  const categories = [
    "Electronics",
    "Cameras",
    "Laptops",
    "Accessories",
    "Headphones",
    "Food",
    "Books",
    "Clothes/Shoes",
    "Beauty/Health",
    "Sports",
    "Outdoor",
    "Home",
  ];
  useEffect(() => {
    if (error) {
      return alert.error(error);
    }
    if (!params.keyword) {
      console.log(params.keyword, "inoiniuniun");
      dispatch(getProducts("", [1, 200000], "", 0));
      return;
    }
    dispatch(getProducts(keyword, price, category, rating));
  }, [dispatch, error, alert, keyword, price, category, rating]);
  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          {console.log("in", products)}
          <MetaData title="Home" />
          <div className="container container-fluid">
            <h1 id="products_heading">Latest Products</h1>

            <section id="products" className="container mt-5">
              <div className="row">
                {keyword ? (
                  <Fragment>
                    <div className="col-6 col-md-3 mt-5 mb-5">
                      <div className="px-5">
                        <Range
                          marks={{
                            1: `Rs.1`,
                            200000: `Rs.200000`,
                          }}
                          min={1}
                          max={200000}
                          defaultValue={[1, 200000]}
                          tipFormatter={(value) => `${value}`}
                          tipProps={{
                            placement: "top",
                            visible: true,
                          }}
                          value={price}
                          onChange={(price) => setPrice(price)}
                        />
                      </div>
                      <hr className="my-5" />

                      <div className="mt-5">
                        <h4 className="mb-3">Categories</h4>

                        <ul className="pl-0">
                          {categories.map((category) => (
                            <li
                              style={{
                                cursor: "pointer",
                                listStyleType: "none",
                              }}
                              key={category}
                              onClick={() => setCategory(category)}
                            >
                              {category}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <hr className="my-3" />

                      <div className="mt-5">
                        <h4 className="mb-3">Ratings</h4>

                        <ul className="pl-0">
                          {[5, 4, 3, 2, 1].map((star) => (
                            <li
                              style={{
                                cursor: "pointer",
                                listStyleType: "none",
                              }}
                              key={star}
                              onClick={() => setRating(star)}
                            >
                              <div className="rating-outer">
                                <div
                                  className="rating-inner"
                                  style={{
                                    width: `${star * 20}%`,
                                  }}
                                ></div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="col-6 col-md-9">
                      <div className="row">
                        {products &&
                          products.map((product) => (
                            <Product
                              key={product._id}
                              product={product}
                              col={4}
                            />
                          ))}
                      </div>
                    </div>
                  </Fragment>
                ) : (
                  products &&
                  products.map((product) => (
                    <Product key={product._id} product={product} col={3} />
                  ))
                )}
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
}
export default Home;
